import React, { useEffect, useState } from 'react';
import './App.css';
import './components/Theme/Theme.css';
import './components/Theme/Style.css';
import ThemeContext from './contexts/ThemeContext';
import Layout from './pages/Layout/Layout';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Services from './pages/Services/Services';
import News from './pages/News/News';
import ArticleDetails from './pages/ArticleDetails/ArticleDetails';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from './pages/LoginPage/LoginPage';
import Dashboard from './pages/Dashboard/Dashboard';
import AboutDashboard from './pages/Dashboard/About/AboutDashboard';
import ServiceDashboard from './pages/Dashboard/Services/ServiceDashboard';
import NewsDashboard from './pages/Dashboard/News/NewsDashboard';
import IndustryDashboard from './pages/Dashboard/Industries/IndustryDashboard';
import IndustryDetails2 from './pages/IndustryDetails/IndustryDetails2';
import axios from 'axios';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';

const App: React.FC = () => {
  const [theme, setTheme] = useState('dark');
  const value = { theme, setTheme };
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get('/api/check-auth', { withCredentials: true });
        setIsAuthenticated(response.status === 200);
      } catch {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  const MyTheme = {
    colors: {
      primary: 'hsl(0, 0%, 95%)',
      background: 'hsl(0, 0%, 2%)',
      accent: '#2662D9',
      card: 'rgb(255, 255, 255)',
      text: 'rgb(28, 28, 30)',
      border: 'rgb(199, 199, 204)',
      notification: 'rgb(255, 69, 58)',
    },
    dark: theme === 'dark',
  };

  const routes = (isAuthenticated: boolean) => (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/news" element={<News />} />
        <Route path="/article/:displayId" element={<ArticleDetails />} />
        <Route path="/industries/:displayId" element={<IndustryDetails2 />} />
        <Route path="/login" element={<LoginPage setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/dashboard" element={<PrivateRoute isAuthenticated={isAuthenticated} />}>
          <Route index element={<Dashboard />} />
          <Route path="about" element={<AboutDashboard />} />
          <Route path="services" element={<ServiceDashboard />} />
          <Route path="news" element={<NewsDashboard />} />
          <Route path="industries" element={<IndustryDashboard />} />
        </Route>
      </Route>
    </Routes>
  );  

  return (
    <ThemeContext.Provider value={value}>
      <div style={{ background: MyTheme.colors.background, color: MyTheme.colors.text } as React.CSSProperties}>
        <BrowserRouter>
          {routes(isAuthenticated)}
        </BrowserRouter>
      </div>
    </ThemeContext.Provider>
  );
};

export default App;
